import { useState } from "react";
import { homeService } from "@miplatform/api";
import { HTTP_STATUSES } from "@miplatform/constants";
import { createUUID } from "@miplatform/utils";

export const useAccountPricingTabViewModel = ({
  stateManager,
  setRequiresPriceConfig,
}) => {
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const GET_CATEGORIES_UUID = createUUID();
  const UPDATE_CATEGORY_UUID = createUUID();

  const getCategories = (accountId) => {
    stateManager.abort(GET_CATEGORIES_UUID);
    stateManager.run(async () => {
      const response = await homeService.accountPricing.getAll({
        accountId,
      });
      if (response.status === HTTP_STATUSES.OK) {
        setCategories(response.data);
        setRequiresPriceConfig((prev) => ({
          ...prev,
          pricing: response.data.some((category) => category.drawTotal !== 100),
        }));
      }
    }, GET_CATEGORIES_UUID);
  };

  const updateCategory = (accountId, categoryId, data) => {
    stateManager.abort(UPDATE_CATEGORY_UUID);
    stateManager.run(async () => {
      const response = await homeService.accountPricing.update({
        accountId,
        categoryId,
        data,
        toastMessageConfig: {
          success: {
            text: "Category pricing distribution updated successfully",
          },
          error: {
            text: "Failed to update category pricing distribution",
          },
        },
      });
      if (response.status === HTTP_STATUSES.OK) {
        getCategories(accountId);
        setSelectedCategory(null);
      }
    }, UPDATE_CATEGORY_UUID);
  };

  return {
    categories,
    selectedCategory,
    getCategories,
    setSelectedCategory,
    updateCategory,
    isLoading: stateManager.isBusy(),
  };
};
